import { FC } from 'react'

import ArrowRightIcon from 'shared/icons/arror_right_icon.svg'

import s from './styles.module.scss'

interface Props {
  text: string
  onClick?: () => void
}

export const BlockArrow: FC<Props> = ({ text, onClick }) => {
  return (
    <div
      className={s.container}
      onClick={onClick}
    >
      <p className={s.title}>{text}</p>

      <img
        src={ArrowRightIcon}
        className={s.arrow}
        alt=""
      />
    </div>
  )
}
